import { render, staticRenderFns } from "./VatRowManager.vue?vue&type=template&id=13403c30&"
import script from "./VatRowManager.vue?vue&type=script&lang=js&"
export * from "./VatRowManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports